import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Route } from 'src/app/core/route.service';
import { AdminDashboardComponent } from './admin-dashboard.component';

const routes: Routes = Route.withShell([
  { path: 'statistics', component: AdminDashboardComponent, data: { title: 'Statistics' } }
]);

@NgModule({
  imports: [
    [RouterModule.forChild(routes)]
  ],
  exports: [RouterModule],
  declarations: []
})
export class AdminDashboardRoutingModule { }
